import { CategoryIdLocatorComponent } from "./categoryid.locator-component";
// Classes.
import { BaseLocator } from "./../locators/base.locator";

export class RecordAreasLocatorComponent extends BaseLocator {
  public recordLevel: CategoryIdLocatorComponent;

  constructor() {
    super("recordsAreas");
    this.addComponentByType("catid", "recordLevel");
  }
}
